<template>
    <div :class="classRowCol" class="mb-2">
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: "RowColComponent",
    props: {
        classRowCol: {
            'type': String,
            "required": true,
        }
    }
}
</script>